import { useEffect, useState } from 'react';
import apiClient, { API_BASE_URL } from '../api/apiClient';
import { resolveFileUrl } from '../utils/fileUrl';

const isApiFileUrl = (url: string) => {
  if (url.startsWith('/api/files/')) return true;
  return url.startsWith(`${API_BASE_URL}/api/files/`);
};

const toApiPath = (url: string) => url.startsWith(API_BASE_URL) ? url.slice(API_BASE_URL.length) : url;

export const useAuthenticatedImageUrl = (url?: string | null) => {
  const [resolvedUrl, setResolvedUrl] = useState<string | undefined>(() =>
    url && !isApiFileUrl(url) ? resolveFileUrl(url) : undefined
  );

  useEffect(() => {
    let objectUrl: string | undefined;
    let cancelled = false;

    const load = async () => {
      if (!url) {
        setResolvedUrl(undefined);
        return;
      }

      if (url.startsWith('data:') || !isApiFileUrl(url)) {
        setResolvedUrl(resolveFileUrl(url));
        return;
      }

      try {
        const response = await apiClient.get(toApiPath(url), { responseType: 'blob' });
        if (cancelled) return;
        objectUrl = URL.createObjectURL(response.data);
        setResolvedUrl(objectUrl);
      } catch {
        if (!cancelled) setResolvedUrl(undefined);
      }
    };

    load();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  return resolvedUrl;
};
